import { motion } from "framer-motion";
import { Globe2 } from "lucide-react";
import { COUNTRIES_SERVED } from "@/data/content";

export default function Countries() {
  return (
    <section
      id="countries"
      data-testid="countries-section"
      className="border-b border-[#E4E7EC] bg-[#0B111A] text-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="overline mb-4 text-[#FDB022]">§ 05 — Forwarder Network</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-white sm:text-5xl md:text-6xl">
              Serving forwarders in <span className="text-[#FDB022]">40+ countries.</span>
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-[#98A2B3]">
            If you're a freight forwarder, 3PL, courier company, or relocation
            agent based anywhere outside India — talk to us. We are the India
            desk for logistics companies across the world.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-0 border border-[#1F2937] md:grid-cols-4">
          {COUNTRIES_SERVED.map((c, i) => (
            <motion.div
              key={c.code}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.35, delay: i * 0.02 }}
              className={`p-5 ${
                (i + 1) % 4 !== 0 ? "border-r border-[#1F2937]" : ""
              } ${i < COUNTRIES_SERVED.length - 4 ? "border-b border-[#1F2937]" : ""} ${
                (i + 1) % 2 === 0 && (i + 1) % 4 !== 0 ? "md:border-r" : ""
              }`}
              data-testid={`country-${c.code}`}
            >
              <div className="flex items-center gap-2">
                <Globe2 className="h-4 w-4 text-[#FDB022]" strokeWidth={2.5} />
                <span className="font-mono-accent text-[#FDB022]">{c.code}</span>
              </div>
              <div className="mt-3 font-display text-lg font-bold tracking-tight text-white">
                {c.name}
              </div>
              <div className="mt-1 text-xs leading-relaxed text-[#98A2B3]">
                {c.note}
              </div>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 max-w-3xl text-sm leading-relaxed text-[#98A2B3]">
          <strong className="text-white">Active partner lanes include:</strong>{" "}
          USA-India air express, Germany-India MRO, UK-India fashion samples,
          UAE-India Gulf express, China-India e-commerce consolidations,
          Singapore-India electronics, Hong Kong-India cross-border D2C,
          Canada-India unaccompanied baggage, Saudi Arabia-India Transfer of
          Residence, Japan-India automotive spares, Netherlands-India pharma
          cold chain, and Türkiye-India textiles.
        </p>
      </div>
    </section>
  );
}
